<div class="employee-menu d-inline-block">
  <div class="d-inline-block">
    <div gp-roles
         [userRoles]="['PAYROLL_READ', 'PAYROLL_WRITE']"
         test-id='stateEmployee'>
      <ng-template #payPeriodStatusesTemplate>
        <div class="status-list-wrapper">
          <div class="status-list">
            <div class="status-list-item" *ngFor="let ppc of payPeriodContracts">
              <div class="label-gp pay-type-status" [ngClass]="ppc.badgeCssClasses">
                {{ ppc.statusToDisplay | translate }}
              </div>
              <div class="pay-type-name"
                   [ngClass]="{'worst-pay-type': ppc.id === worstPayPeriodContract.id}">
                {{ ppc.payTypeTransId | translate }}
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <span *ngIf="worstPayPeriodContract">
        <span [tooltip]="worstPayPeriodContract.payTypeTransId" placement="top">
          <span class="label-gp" [ngClass]="worstPayPeriodContract.badgeCssClasses"
                [popover]="payPeriodStatusesTemplate" [outsideClick]="true"
                containerClass="popover-no-padding"
                placement="bottom" container="body" role="button">
              {{ worstPayPeriodContract.statusToDisplay | translate }}
            <i class="fa fa-light fa-caret-down text-right status-caret" aria-hidden="true"></i>
          </span>
        </span>
      </span>
    </div>
  </div>
  <div class="d-inline-block m-l-sm">
    <ng-container *ngIf="readOnly">
      <div class="separator-space"></div>
    </ng-container>
    <div class="dropdown d-inline-block"
         [class.open]="menuItems.opened"
         (click-outside)="menuItems.opened = false"
         *ngIf="!readOnly">
      <button class="btn white dropdown-toggle"
              test-id="QuickActionsButton"
              type="button"
              [disabled]="isSendingOnboarding"
              (click)="menuItems.opened = !menuItems.opened"
              *ngIf="hasVisibleChild()">
        {{ 'EMPLOYEE_MANAGE.quick_actions' | translate }}
      </button>
      <ul #items class="dropdown-menu" style="top: 20%;">
        <li gp-roles [userRoles]="['ADMIN','DEBUG_FLATTEN','DEBUG_CHECK','DEBUG_FORCE_REFRESH']"
            class="dropdown-item"
            *ngIf="contractId">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          <i class="fa fa-light fa-bug" aria-hidden="true"></i>Debugging
          <ul class="dropdown-menu dropdown-submenu dropdown-submenu-left">
            <li (click)="openDebugFlatten(contractId)"
                class="dropdown-item pointer"
                gp-roles [userRoles]="['ADMIN','DEBUG_FLATTEN']">
              Open flatten
            </li>
            <li (click)="openDebugCheck(contractId)"
                class="dropdown-item pointer"
                gp-roles [userRoles]="['ADMIN','DEBUG_CHECK']">
              Debug check
            </li>
            <li (click)="forceRefresh(contractId)"
                class="dropdown-item pointer"
                [ngClass]="{'disabled': forceRefreshed}"
                gp-roles [userRoles]="['ADMIN','DEBUG_FORCE_REFRESH']">
              Force refresh & send
            </li>
            <li (click)="forceRefresh(contractId, false)"
                class="dropdown-item pointer"
                [ngClass]="{'disabled': forceRefreshed}"
                gp-roles [userRoles]="['ADMIN','DEBUG_FORCE_REFRESH']">
              Force refresh only
            </li>
            <li (click)="openDebugMapPerson(contractId)"
                class="dropdown-item pointer"
                gp-roles [userRoles]="['SDC3_ADMIN']">
              Debug map person (SDC3)
            </li>
            <li (click)="openDebugMapPayroll(contractId)"
                class="dropdown-item pointer"
                gp-roles [userRoles]="['SDC3_ADMIN']">
              Debug map payroll (SDC3)
            </li>
          </ul>
        </li>
        <li [userRoles]="['PEOPLE_USER_CREATION']" gp-roles>
          <gp-user-action-list
            [employee]="employee"
            [contract]="contract"
            [readonly]="contract?.readOnly"
            (userUpdate)="onUserUpdate($event)"
            (modalOpen)="onModalOpen()">
          </gp-user-action-list>
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_READ','PEOPLE_WRITE']"
            (click)="routeTo('/employees/files', contractId)"
            class="dropdown-item pointer"
            *ngIf="contractId && !hiddenItems.modify">
          {{ 'EMPLOYEE_MANAGE.see_employee_file' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PAYROLLPREPARE_READ', 'PAYROLLPREPARE_WRITE']"
            (click)="routeTo('/payroll/prepare', contractId)"
            class="dropdown-item pointer"
            *ngIf="contractId && !hiddenItems.payrollPrepare">
          {{ 'PAYROLL_PREPARE.prepare_payroll' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_WRITE']"
            class="dropdown-item"
            *ngIf="payPeriodContractsUtils.isActionInAnyPayPeriodContract(payPeriodContracts, actionLaunch) && !contract?.readOnly">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          {{ 'EMPLOYEE_MANAGE.launch_payroll' | translate }}
          <ul class="dropdown-menu pointer dropdown-submenu dropdown-submenu-left">
            <ng-container *ngFor="let payTypeGroup of payTypesMap | keyvalue : payTypeCalculationTypeComparator">
              <ng-container *ngFor="let ppc of payTypeGroup.value | sortByTranslations:
                         triggerSortByTranslationPipe :['payTypeTransId'] | async; let i = index">
                <li *ngIf="payPeriodContractsUtils.isActionInPayPeriodContract(ppc, actionLaunch)"
                    (click)="openLaunchPayrollModal(ppc.id)"
                    class="dropdown-item pointer"
                    [class.context-select-group]="i === 0">
                  {{ ppc.payTypeTransId | translate }}
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_WRITE']"
            class="dropdown-item"
            *ngIf="payPeriodContractsUtils.isActionInAnyPayPeriodContract(payPeriodContracts, actionDone) && !contract?.readOnly">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          {{ 'EMPLOYEE_MANAGE.done_payroll' | translate }}
          <ul class="dropdown-menu pointer dropdown-submenu dropdown-submenu-left">
            <ng-container *ngFor="let ppc of payPeriodContracts">
              <li *ngIf="payPeriodContractsUtils.isActionInPayPeriodContract(ppc, actionDone)"
                  (click)="executePayroll('done', ppc.id)"
                  class="dropdown-item pointer">
                {{ ppc.payTypeTransId | translate }}
              </li>
            </ng-container>
          </ul>
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_WRITE']"
            class="dropdown-item"
            *ngIf="payPeriodContractsUtils.isActionInAnyPayPeriodContract(payPeriodContracts, actionFix) && !contract?.readOnly">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          {{ 'EMPLOYEE_MANAGE.freeze_payroll' | translate }}
          <ul class="dropdown-menu pointer dropdown-submenu dropdown-submenu-left">
            <ng-container *ngFor="let ppc of payPeriodContracts">
              <li *ngIf="payPeriodContractsUtils.isActionInPayPeriodContract(ppc, actionFix)"
                  (click)="executePayroll('freeze', ppc.id)"
                  class="dropdown-item pointer">
                {{ ppc.payTypeTransId | translate }}
              </li>
            </ng-container>
          </ul>
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_WRITE']"
            class="dropdown-item"
            *ngIf="payPeriodContractsUtils.isActionInAnyPayPeriodContract(payPeriodContracts, actionUnfreeze) && !contract?.readOnly">
          <em class="fa fa-light fa-caret-right"></em>
          {{ 'EMPLOYEE_MANAGE.unfreeze_payroll' | translate }}
          <ul class="dropdown-menu pointer dropdown-submenu dropdown-submenu-left">
            <ng-container *ngFor="let ppc of payPeriodContracts">
              <li *ngIf="payPeriodContractsUtils.isActionInPayPeriodContract(ppc, actionUnfreeze)"
                  (click)="executePayroll('unfreeze', ppc.id)"
                  class="dropdown-item pointer">
                {{ ppc.payTypeTransId | translate }}
              </li>
            </ng-container>
          </ul>
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_WRITE']"
            class="dropdown-item"
            *ngIf="payPeriodContractsUtils.isActionInAnyPayPeriodContract(payPeriodContracts, actionLastDone) && !contract?.readOnly">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          {{ 'EMPLOYEE_MANAGE.last_done_payroll' | translate }}
          <ul class="dropdown-menu pointer dropdown-submenu dropdown-submenu-left">
            <ng-container *ngFor="let ppc of payPeriodContracts">
              <li *ngIf="payPeriodContractsUtils.isActionInPayPeriodContract(ppc, actionLastDone)"
                  (click)="openLastDoneModal(ppc.id)"
                  class="dropdown-item pointer">
                {{ ppc.payTypeTransId | translate }}
              </li>
            </ng-container>
          </ul>
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_READ', 'PAYROLL_WRITE']"
            (click)="routeTo('/payroll/analyze', contractId, {tab: 'Overview'})"
            class="dropdown-item pointer"
            *ngIf="contractId && !hiddenItems.seePayrollResults && payPeriodContractsUtils.isLastExecInAnyPayPeriodContract(payPeriodContracts)">
          {{ 'EMPLOYEE_MANAGE.see_payroll_results' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PAYROLL_WRITE']"
            (click)="openTestCreationModal()"
            class="dropdown-item pointer"
            *ngIf="contractId && displayHawkTestModal">
          {{ 'PAYROLL_TESTING.hawk_test' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_HIRE']"
            (click)="routeTo('/employees/hire', employeeId)"
            class="dropdown-item pointer"
            *ngIf="employeeId && !contract?.readOnly">
          {{ 'EMPLOYEE_MANAGE.add_contract' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_EXTEND']"
            (click)="routeTo('/employees/extend', contractId)"
            class="dropdown-item pointer"
            *ngIf="contractId && !contract?.readOnly && isExtendWorkFlowAvailable">
          {{ 'EMPLOYEE_MANAGE.extend_contract' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_TERMINATE']"
            (click)="terminateContract()"
            class="dropdown-item pointer"
            *ngIf="contractId && !contract?.readOnly">
          {{ 'EMPLOYEE_MANAGE.terminate_contract' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_TERMINATE']"
            (click)="openRevertTerminationModal()"
            class="dropdown-item pointer"
            *ngIf="contractId && !contract?.readOnly && isRevertTerminationAvailable">
          {{ 'EMPLOYEE_MANAGE.revert_termination_contract' | translate }}
        </li>
        <li gp-roles
            [userRoles]="['PEOPLE_DELETE']"
            (click)="openDeleteContractModal()"
            class="dropdown-item pointer">
          {{ 'EMPLOYEE_MANAGE.delete_contract' | translate }}
        </li>
        <li class="dropdown-item"
            *ngIf="!hiddenItems.communication || menuItems.communications?.length || newOnboardingEnabled">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          {{ 'EMPLOYEE_MANAGE.communication' | translate }}
          <ul class="dropdown-menu pointer dropdown-submenu dropdown-submenu-left">
            <li *ngFor="let communication of menuItems.communications | sortByTranslations:
                         triggerSortByTranslationPipe :['descriptionTransId'] | async"
                (click)="selectReportDefinition(communication)"
                class="dropdown-item pointer">
              {{ communication.descriptionTransId | translate }}
            </li>
            <li *ngIf="newOnboardingEnabled"
                (click)="!isOnboardingInProgress() && sendOnboardingV2()"
                class="dropdown-item"
                [ngClass]="{'disabled': isOnboardingInProgress(), 'no-pointer': isOnboardingInProgress(), 'pointer': !isOnboardingInProgress()}"
                [tooltip]="isOnboardingInProgress() ? ('ONBOARDING.process_in_progress' | translate) : ''"
                placement="left"
                container="body">
              <i aria-hidden="true"></i>
              <span>{{ 'Onboarding.send_onboarding' | translate }}</span>
            </li>
          </ul>
        </li>
        <li *ngIf="managerOrganizations" class="dropdown-item">
          <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
          {{ 'EMPLOYEE_MANAGE.view_manage' | translate }}
          <ul class="dropdown-menu dropdown-submenu dropdown-submenu-left">
            <li *ngFor="let orgKey of managerOrganizations | keys"
                class="dropdown-item pointer">
              <i class="fa fa-light fa-caret-right" aria-hidden="true"></i>
              {{ orgKey | translate }}
              <ul class="dropdown-menu dropdown-submenu dropdown-submenu-left">
                <ng-container *ngIf="managerOrganizations[orgKey]?.length">
                  <li *ngFor="let manager of managerOrganizations[orgKey]"
                      class="dropdown-item pointer"
                      (click)="navigateToManager(manager.id)">
                    <div class="emp">
                      <div class="emp-avatar">
                        <span class="circle avatar avatar-text w-32" *ngIf="manager.photo; else noPhoto">
                          <img (error)=onManagerImageError(manager)
                               [attr.src]="api.apiHost + manager.photo.href" alt="managerPhoto">
                        </span>
                        <ng-template #noPhoto>
                          <gp-user-avatar
                            [initials]="getManagerInitials(manager.nodeName)"
                            size="sm">
                          </gp-user-avatar>
                        </ng-template>
                      </div>
                      <div class="emp-info">
                        <div>{{ manager.nodeName }}</div>
                        <small class="text-muted">{{ manager.positionName }}</small>
                      </div>
                    </div>
                  </li>
                </ng-container>
                <li *ngIf="!managerOrganizations[orgKey]?.length"
                    class="dropdown-item">
                  {{ 'EMPLOYEE_MANAGE.no_managers' | translate }}
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>


<gp-modal gp-modal="launchPayrollModal" [closable]="true" size="sm">
  <div class="gp-modal-title" style="max-width: 90%">
    <h4 class="text-ellipsis">{{ 'FORMS.confirm' | translate }}</h4>
  </div>
  <div class="gp-modal-body">
    <form novalidate>
      <div class="row">
        <div class="col-md-12 form-group">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="isDebuggingMode" name="isDebuggingMode">
            {{ 'PAYROLL_ONGOING.debugging_mode' | translate }}
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="isForceRetroactivity" name="forceRetroactivity">
            {{ 'PAYROLL_ONGOING.force_retroactivity' | translate }}
          </label>
        </div>
      </div>
      <div class="row" *ngIf="isForceRetroactivity">
        <div class="col-md-6 form-group">
          <label>{{ 'PAYROLL_ONGOING.force_retroactivity_until' | translate }}:</label>
        </div>
        <div class="col-md-6 form-group">
          <datepicker-input [(ngModel)]="retroactivityDate" name="retroactivityDate">
          </datepicker-input>
        </div>
      </div>
    </form>
  </div>
  <div class="gp-modal-footer">
    <button type="button"
            class="btn dark-white p-x-md"
            (click)="closeLaunchPayrollModal()">
      {{ 'FORMS.cancel' | translate }}
    </button>
    <button test-id="payrollConfirm"
            class="btn btn-dark p-x-md"
            (click)="submitLaunchPayrollModal(currentPayPeriodContractId)">
      {{ 'FORMS.confirm' | translate }}
    </button>
  </div>
</gp-modal>

<gp-modal gp-modal="workflowFormModal"
          [closable]="true"
          [submittable]="false"
          [cancellable]="false"
          #workflowFormModal>
  <div class="gp-modal-title">
    {{ REQUEST_TITLE_TRANSLATE_PREFIX + selectedWorkflowName | translate }}
  </div>
  <div class="gp-modal-body">
    <gp-workflow-form *ngIf="workflowFormModel"
                      [formModel]="workflowFormModel"
                      (cancelFormOutcome)="closeModal()"
                      (submitFormOutcome)="onCloseWorkflowForm($event)">
    </gp-workflow-form>
  </div>
</gp-modal>

<gp-report-definition *ngIf="cliRegId && contractId"
                      [cliRegIds]="[cliRegId]"
                      [contractId]="contractId"
                      [employeeId]="employeeId"
                      [hiddenValues]="hiddenValuesForReportDefinition"
                      [types]="availableReportsType"
                      [selectedReportDefinition]="selectedReportDefinition"
                      (reportDefinitionsLoaded)="reportDefinitionsLoaded($event)"
                      (reportDefinitionListener)="reportDefinitionListener($event)">
</gp-report-definition>

<gp-delete-contract-modal
  [contracts]="contracts"
  [employeeId]="employeeId"
></gp-delete-contract-modal>
